export const SHOW_FOOTER = Symbol('SHOW_FOOTER');
export const HIDE_FOOTER = Symbol('HIDE_FOOTER');

export function showFooter() {
    return {
        type: SHOW_FOOTER
    }
}

export function hideFooter() {
    return {
        type: HIDE_FOOTER
    }
}